import { render, staticRenderFns } from "./EditWorkOrderStatus.vue?vue&type=template&id=fc33132a&scoped=true&"
import script from "./EditWorkOrderStatus.vue?vue&type=script&lang=js&"
export * from "./EditWorkOrderStatus.vue?vue&type=script&lang=js&"
import style0 from "./EditWorkOrderStatus.vue?vue&type=style&index=0&id=fc33132a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc33132a",
  null
  
)

export default component.exports